import { PAGINATION } from '../../constants/common/pagination';

export const SEARCH_CAR_STORAGE_KEY = `${PAGINATION.SELL_CAR_LIST}_search`;
export const SEARCH_BIKE_STORAGE_KEY = `${PAGINATION.SELL_BIKE_LIST}_search`;
export const SEARCH_COMMERCIAL_STORAGE_KEY = `${PAGINATION.SELL_COMMERCIAL_LIST}_search`;

export const SEARCH_SESSION_KEYS = [
    SEARCH_CAR_STORAGE_KEY,
    SEARCH_BIKE_STORAGE_KEY,
    SEARCH_COMMERCIAL_STORAGE_KEY,
];

export const clearVehicleSearchSessionStorage = () => {
    if (typeof sessionStorage === 'undefined') return;

    SEARCH_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
};
